import React from 'react';
import type { NextPage } from 'next';
import { CmsThemes, type TLocale } from 'src/lib/constants';
import type { Entry, Sys } from 'src/types/contentful-sdk-compat';
import { BlogOverviewTemplate } from 'src/templates/BlogOverviewTemplate';

type PageMetaFields = {
  heading: string;
  metaDescription: string;
  metaTitle: string;
  pageSlug: string;
};

type BlogPost = {
  fields: PageMetaFields;
  sys: Sys;
};

type PagedPostsProps = {
  posts: Entry<BlogPost>[];
  overviewFields: PageMetaFields;
  pageNum: number;
  totalPages: number;
  allTags: string[];
  locale?: TLocale;
};

const BlogPagedPage: NextPage<PagedPostsProps> = ({
  posts,
  overviewFields,
  pageNum,
  totalPages,
  allTags,
  locale,
}) => {
  return (
    <BlogOverviewTemplate
      fields={overviewFields}
      posts={posts}
      heading={overviewFields.heading}
      pageNum={pageNum}
      totalPages={totalPages}
      basePath='/blog'
      noIndex={true}
      allTags={allTags}
      cmsTheme={CmsThemes.WEB3}
      locale={locale}
    />
  );
};

export default BlogPagedPage;
